import React, { useEffect, useState } from 'react';
import InfoCard from '../InfoCard'; // Ajustá si la ruta es distinta
import userAuth from "../../Config/userauth";
import { APPCONFIG } from '../../app.config';

const HomeAccountManagerInfo = () => {
  const [ejecutivoInfo, setEjecutivoInfo] = useState({ avatar: '', name: '' });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const userId = userAuth.isGestor() ? userAuth.reportTo() : userAuth.cuitProducer();
    loadEjecutivoInfo(userId);
  }, []);

  const loadEjecutivoInfo = async (userId) => {
    const { PRODUCERURL } = APPCONFIG.ENDPOINTS;

    try {
      const response = await fetch(`${PRODUCERURL}api/producer/GetAccountManagerByCuit?cuit=${userId}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      });

      if (!response.ok) {
        const errorText = await response.text();
        setError(errorText);
        setLoading(false);
        return;
      }

      const data = await response.json();

      if (data?.success) {
        setEjecutivoInfo(data);
        setError(null);
      } else {
        setError("No se pudo procesar la información");
      }

    } catch (err) {
      setError("Error inesperado al obtener los datos");
    } finally {
      setLoading(false);
    }
  };

  const renderField = (icon, content) => (
    <div className="row pb-3">
      <div className="col-1 campo-titulo"><i className={`fa ${icon}`} /></div>
      <div className="col-10 campo-valor">{content}</div>
    </div>
  );
  

  const formatPhoneLink = (phone) => {
    if (!phone) return 'Sin datos';
    const number = phone.replace('+', '').replace('-', '').replace(/ /g, '');
    return (
      <a target="_blank" rel="noopener noreferrer" href={`https://wa.me/${number}`}>
        {phone}
      </a>
    );
  };

  return (
    <InfoCard title="Mi ejecutivo de cuenta" icon="fa-user">
      {loading ? (
        <div className="text-center">Cargando datos...</div>
      ) : (
        <>
          <div className="row justify-content-between">
            <span className="d-flex flex-column col">
              {renderField("fa-user", ejecutivoInfo.name || 'Sin datos')}
              {renderField("fa-phone", formatPhoneLink(ejecutivoInfo.telephone))}
              {renderField("fa-envelope", ejecutivoInfo.email || 'Sin datos')}
            </span>
            <div className="col-auto">
              {ejecutivoInfo.avatar ? (
                <img
                  src={ejecutivoInfo.avatar}
                  alt="avatar"
                  style={{ width: '60px', borderRadius: '50%' }}
                />
              ) : (
                <i className="fas fa-image" style={{ fontSize: '2.5rem', color: '#ccc' }} />
              )}
            </div>
          </div>

          {error && (
            <div className="text-danger text-center mt-2">
              {error}
            </div>
          )}
        </>
      )}
    </InfoCard>
  );
};

export default HomeAccountManagerInfo;
